import { Type } from "class-transformer";
import { EnaioWatcherResult } from "./EnaioWatcherResult";

export class EnaioWatcher {
    guid: string;
    @Type(() => EnaioWatcherResult)
    results: EnaioWatcherResult[];
}
